/** A tracker state report. Tobii owns calibration, so there is no flow here. */

import {
  Banner,
  DataList,
  EmptyState,
  Panel,
  Skeleton,
  Stack,
  StatusBadge,
} from "@/components/ui";

import { AgentProblem } from "./AgentProblem";
import { orNone } from "./format";
import { useAgentStatus } from "./queries";

export function AgentCalibration() {
  const status = useAgentStatus();

  if (status.isPending) {
    return <Skeleton height="14rem" />;
  }
  if (status.isError) {
    return <AgentProblem error={status.error} onRetry={() => void status.refetch()} />;
  }

  const data = status.data;

  return (
    <Stack gap={5}>
      {data.gaze_mode === "replay" ? <Banner tone="warning" title="Gaze substituted" /> : null}

      <Panel title="Tracker">
        {data.tracker === null ? (
          <EmptyState bare headline="No tracker" />
        ) : (
          <DataList
            items={[
              {
                id: "tracker",
                title: data.tracker,
                badge: <StatusBadge tone="success">Present</StatusBadge>,
                fields: [
                  { label: "Gaze mode", value: orNone(data.gaze_mode) },
                  { label: "Samples", value: data.gaze_samples_published },
                ],
              },
            ]}
          />
        )}
      </Panel>

      <div aria-live="polite">
        <Panel title="Calibration">
          <EmptyState bare headline="Not reported" />
        </Panel>
      </div>

      {data.tracker === null ? (
        <>
          <Panel title="Check">
            <DataList
              items={[
                { id: "cable", title: "Cable" },
                { id: "service", title: "Tobii Service" },
                { id: "generic", title: "TobiiGeneric" },
                { id: "eyetracker5", title: "TobiiIS5LEYETRACKER5" },
              ]}
            />
          </Panel>
          <Panel title="Unavailable">
            <DataList items={[{ id: "gaze", title: "Gaze activities" }]} />
          </Panel>
        </>
      ) : null}
    </Stack>
  );
}
